import { Loader } from 'cdk-radial';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useIsFetching } from 'react-query';
import { EVENT_NAME } from 'common/constants';
import { useAmplitude } from 'components/AmplitudeProvider';
import { useAppSelector } from 'store/hooks';
import { amplitudeTracker } from 'utils/AmplitudeTracker';
import {
  VendorPaymentSuccessTable,
  VendorPaymentFailedTable,
  PaymentResultHeader
} from './components';

import { labelMessages } from './messages';
import {
  getFailedRecords,
  getCompletedRecords,
  getPaymentDate
} from './selectors';
import { PaymentResultGridStyle, StyledContainer } from './styled';

export const VendorPaymentResultPage = (): React.JSX.Element => {
  const amplitude = useAmplitude();
  const isFetchingPDFData = useIsFetching(['pdfGeneration']);
  const paymentDate = useAppSelector(getPaymentDate);
  const failedData = useAppSelector(getFailedRecords);
  const successData = useAppSelector(getCompletedRecords);
  const intl = useIntl();

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (successData.length)
      amplitudeTracker(amplitude, EVENT_NAME.AuthorizePaymentSuccess, {
        'Successful Payments': successData.length
      });
    if (failedData.length)
      amplitudeTracker(amplitude, EVENT_NAME.AuthorizePaymentFailure, {
        'Fail Reason': failedData.map(data => data.failReason).join(','), // reason for failure from API ,
        'Fail Entry Total': failedData.length
      });
  }, [successData, failedData]);

  return (
    <>
      <StyledContainer>
        <PaymentResultHeader paymentDate={paymentDate} />
        {!!isFetchingPDFData && (
          <Loader data-testid="loader" variant="inline" />
        )}
        <PaymentResultGridStyle>
          {failedData?.length > 0 && (
            <VendorPaymentFailedTable
              data={failedData}
              tableHeaderTitle={intl.formatMessage(labelMessages.failedHeader)}
            />
          )}
          {successData?.length > 0 && (
            <VendorPaymentSuccessTable
              data={successData}
              tableHeaderTitle={intl.formatMessage(labelMessages.successHeader)}
            />
          )}
        </PaymentResultGridStyle>
      </StyledContainer>
    </>
  );
};
